import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col gap-y-8"
}

import { useFiltersStore } from "../stores/filters";
import FilterSection from "@js/components/filters/FilterSection.vue";
import SearchFilter from "@js/components/filters/SearchFilter.vue";
import CheckboxFilter from "@js/components/filters/CheckboxFilter.vue";
import RadioFilter from "@js/components/filters/RadioFilter.vue";
import LoadingIndicator from "@js/components/LoadingIndicator.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageFilters',
  setup(__props) {

const store = useFiltersStore();
store.getFilters();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(store).folders.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(FilterSection, { heading: "Søk i alle bilder" }, {
            default: _withCtx(() => [
              _createVNode(SearchFilter, {
                onSearch: _cache[0] || (_cache[0] = (v) => (_unref(store).searchQuery = v))
              })
            ]),
            _: 1
          }),
          _createVNode(FilterSection, { heading: "Filtrer på bildetype" }, {
            default: _withCtx(() => [
              _createVNode(RadioFilter, {
                name: "folder",
                options: _unref(store).folders,
                modelValue: _unref(store).folder,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(store).folder) = $event)),
                "num-items-above-fold": null
              }, null, 8, ["options", "modelValue"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(LoadingIndicator, {
      "is-loading": _unref(store).isLoading
    }, null, 8, ["is-loading"])
  ]))
}
}

})